<template>
  <div class="sc-chat-window" :class="{opened: isOpen, closed: !isOpen}">
    <ListUsers v-show="!escolheuCliente"
      :clientes="mensagens" @selectedCliente="selectedCliente" @atualizarImagem="atualizarImagem"
    />
    <Header v-if="escolheuCliente"
      :teamName="clienteEscolhido.nome"
      :imageUrl="clienteEscolhido.img"
      :onClose="onClose"
      @back="backChat"
    />
    <MessageList v-if="escolheuCliente"
      :messages="messageList"
      :imageUrl="clienteEscolhido.img"
      :chatImageUrl="clienteEscolhido.img"
    />
    <UserInput v-show="escolheuCliente" :showEmoji="showEmoji" :onSubmit="onUserInputSubmit" :showFile="showFile" :placeholder="placeholder" @sendMsg="sendMsg"/>
  </div>
</template>

<script>
import Header from './Header.vue'
import MessageList from './MessageList.vue'
import UserInput from './UserInput.vue'
import ListUsers from './ListUsers.vue'

export default {
  components: {
    Header,
    MessageList,
    UserInput,
    ListUsers
  },
  props: {
    'mensagens': {
      type: Array,
      default: () => []
    },
    'showEmoji': {
      type: Boolean,
      default: false
    },
    'showFile': {
      type: Boolean,
      default: false
    },
    'onUserInputSubmit': {
      type: Function,
      required: true
    },
    'onClose': {
      type: Function,
      required: true
    },
    'isOpen': {
      type: Boolean,
      default: () => false
    },
    'escolheuCliente': {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String,
      default: "Envie uma resposta"
    }
  },
  data () {
    return {
      messageList: [],
      clienteEscolhido: {
        nome: '',
        img: '',
        id: ''
      }
    }
  },
  methods: {
    selectedCliente(id) {
      console.log("id ", id)
      this.$emit('escolheuCliente', id);
      this.mensagens.forEach(element => {
        if(element.id === id) {
          this.clienteEscolhido.nome = element.nome;
          this.clienteEscolhido.img = element.img;
          this.clienteEscolhido.id = element.id;
          this.messageList = element.mensagem
          this.escolheuCliente = true
          return
        }
      });
    },
    sendMsg(msg) {
      let sendBack = {
        autor: msg.author,
        id: this.clienteEscolhido.id,
        mensagem: msg.data.text,
        date: new Date()
      }
      this.mensagens.forEach((element, index) => {
        if(element.id == this.clienteEscolhido.id) {
          this.mensagens[index].mensagem.push(msg);
          console.log('messages -> ', this.mensagens)

        }
      })
      this.$emit('sendMsg', sendBack);
    },
    atualizarImagem(id) {
      console.log('atualizando chatwindow ', id)
        this.$emit('atualizarImagem', id);
    },
    backChat() {
      this.$emit('backChat', null);
      this.escolheuCliente = false
    }
  }
}
</script>
<style scoped>
.sc-chat-window {
  width: 370px;
  height: calc(100% - 170px);
  max-height: 590px;
  position: fixed;
  right: 25px;
  bottom: 100px;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(148, 149, 150, 0.3);
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  border-radius: 10px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.sc-chat-window.closed {
  opacity: 0;
  visibility: hidden;
  bottom: 90px;
}

.sc-message--me {
  text-align: right;
}
.sc-message--them {
  text-align: left;
}

@media (max-width: 450px) {
  .sc-chat-window {
    width: 100%;
    height: 100%;
    max-height: 100%;
    right: 0px;
    bottom: 0px;
    border-radius: 0px;
  }
  .sc-chat-window {
    transition: 0.1s ease-in-out;
  }
  .sc-chat-window.closed {
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// ChatWindow.vue?484806a3